module.exports = __webpack_public_path__ + "static/img/weather_rain.6277093.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weather_rain.png
// module id = vTlo
// module chunks = 2